export default __webpack_public_path__ + "static/media/backgroundNew.7a6cb096.png";